document.addEventListener('DOMContentLoaded', function() {
  const lang = document.documentElement.lang;
  
  if (lang === 'fr') {
    
    function translateDiscountTable() {
      const discountTable = document.querySelector('.hulkapps-volume-discount-tiers table, .hulkapps-table');
      
      if (discountTable) {
        let html = discountTable.innerHTML;
        
        // Only translate if still in English
        if (html.includes('Minimum Qty') || html.includes('Discount') || html.includes('Buy')) {
          html = html.replace(/Minimum Qty/gi, 'Quantité minimale');
          html = html.replace(/Discount/gi, 'Rabais');
          html = html.replace(/Off each portion/gi, 'de rabais par portion');
          html = html.replace(/each portion/gi, 'par portion');
          html = html.replace(/Buy/gi, 'Achetez');
          
          discountTable.innerHTML = html;
        }
      }
    }
    
    // Try multiple times to catch when the app loads
    setTimeout(translateDiscountTable, 100);
    setTimeout(translateDiscountTable, 500);
    setTimeout(translateDiscountTable, 1000);
    setTimeout(translateDiscountTable, 2000);
  }
});
